import React, { useEffect, useState } from "react";
import AdminLTE, {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { validateEmail } from "../utils/utils";
import moment from "moment";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";
import SelectInput from "../utils/SelectInput";
import controllerLocal from "../locales/duck";

const crearAsistenciaOptions = () => [
  { value: "SI", label: "SI" },
  { value: "NO", label: "NO" },
];
const { Text } = Inputs;

function AddContacto({ history, match }) {
  const dispatch = useDispatch();

  const modelAddContacto = useSelector((state) => state.addContacto);
  const modelReservas = useSelector((state) => state.reservaOptions);
  const modelLocal = useSelector((state) => state.localById);

  const [reservaOptions, setReservaOptions] = useState([]);
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [documento, setDocumento] = useState("");
  const [direccion, setDireccion] = useState("");
  const [email, setEmail] = useState("");
  const [ts, setTs] = useState(moment().format("YYYY-MM-DD"));
  const [localId, setLocalId] = useState(
    match.params.organizacion ? match.params.organizacion : null
  );
  const [crearAsistencia, setCrearAsistencia] = useState("SI");
  const [poseeReserva, setPoseeReserva] = useState("NO");
  const [reserva, setReserva] = useState(null);
  const [fechaNacimiento, setFechaNacimiento] = useState("");
  const [camposContacto, setCamposContacto] = useState(null);

  useEffect(() => {
    dispatch(controller.getReservaOptionsThunk({ id: localId }));
    dispatch(controllerLocal.localByIdThunk(localId));
  }, []);

  useEffect(() => {
    const data = modelLocal?.data?.data;
    const error = modelLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerLocal.duckLocalById.actions.clear());
    }
    if (data && data.data) {
   

      if (data.data.detalles.camposContacto) {
        setCamposContacto(data.data.detalles.camposContacto);
      }

      dispatch(controllerLocal.duckLocalById.actions.clear());
    }
  }, [modelLocal]);

  useEffect(() => {
    const data = modelAddContacto?.data?.data;
    const error = modelAddContacto?.error?.response?.data?.mensaje;
   
    if (error) {
      alert(error);
      dispatch(controller.duck.actions.clear());
    }
    if (data) {
      history.push(`/contactos/${localId}`);
      dispatch(controller.duck.actions.clear());
    }
  }, [modelAddContacto]);

  useEffect(() => {
    const data = modelReservas?.data?.data;
    const error = modelReservas?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckReservaOptions.actions.clear());
    }
    if (data) {

      setReservaOptions(data.data);
      dispatch(controller.duckReservaOptions.actions.clear());
    }
  }, [modelReservas]);

  function submit() {
    if (
      camposContacto?.fechaNacimiento?.habilitado &&
      camposContacto?.fechaNacimiento?.required && !fechaNacimiento
    ) {
      alert("Por favor ingrese una fecha de nacimiento");
      return;
    }
    if (
      camposContacto?.direccion?.habilitado &&
      camposContacto?.direccion?.required && !direccion
    ) {
      alert("Por favor ingrese una direccion");
      return;
    }
    if (camposContacto?.email?.habilitado && camposContacto?.email?.required && !email) {
      alert("Por favor ingrese un email");
      return;
    }
    if (email && !validateEmail(email)) {
      alert("Por favor proporcione un email con el formato correcto");
      return;
    }

    if (
      camposContacto?.telefono?.habilitado &&
      camposContacto?.telefono?.required && !telefono
    ) {
      alert("Por favor ingrese un numero de telefono");
      return;
    }
    if (!nombre || !documento) {
      alert("Por favor ingrese el nombre y documento");
      return;
    }

    if (!localId) {
      alert("No se ha podido obtener el ID del local");
      return;
    }

    if (poseeReserva === "SI" && !reserva) {
      alert("Seleccione una reserva");
      return;
    }

    let data = {
      nombre,
      telefono,
      documento,
      ts,
      direccion,
      email,
      localId,
      crearAsistencia: "NO",
      fechaNacimiento,
    };

    dispatch(controller.addContactoThunk(data));
  }

  return (
    <Content title="Nuevo contacto" browserTitle="Nuevo contacto" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Nuevo contacto"
            footer={
              <>
                <Button text="Cancelar" onClick={() => history.goBack()} />

                <Button
                  type="primary"
                  text="Guardar"
                  pullRight={true}
                  disabled={modelAddContacto.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <ReferenciaObligatorios />
            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nombre" obligatorio={true} />}
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Documento" obligatorio={true} />}
              value={documento}
              onChange={(evt) => setDocumento(evt.target.value)}
            />
            {camposContacto?.telefono?.habilitado ? (
              <Text
                labelPosition="above"
                size="sm"
                label={
                  camposContacto?.telefono?.required ? (
                    <Etiqueta texto="Telefono" obligatorio={true} />
                  ) : (
                    "Telefono"
                  )
                }
                value={telefono}
                inputType="number"
                onChange={(evt) => setTelefono(evt.target.value)}
              />
            ) : null}

            {camposContacto?.email?.habilitado ? (
              <Text
                labelPosition="above"
                size="sm"
                label={
                  camposContacto?.email?.required ? (
                    <Etiqueta texto="Email" obligatorio={true} />
                  ) : (
                    "Email"
                  )
                }
                value={email}
                onChange={(evt) => setEmail(evt.target.value)}
              />
            ) : null}

            {camposContacto?.direccion?.habilitado ? (
              <Text
                labelPosition="above"
                size="sm"
                label={
                  camposContacto?.direccion?.required ? (
                    <Etiqueta texto="Direccion" obligatorio={true} />
                  ) : (
                    "Direccion"
                  )
                }
                value={direccion}
                onChange={(evt) => setDireccion(evt.target.value)}
              />
            ) : null}
            {camposContacto?.fechaNacimiento?.habilitado ? (
              <div style={{ marginBottom: 15 }}>
                <label>
                  {camposContacto?.fechaNacimiento?.required ? (
                    <Etiqueta texto="Fecha de nacimiento" obligatorio={true} />
                  ) : (
                    "Fecha de nacimiento"
                  )}
                </label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  customInput={<input type="text" className="form-control" />}
                  selected={fechaNacimiento}
                  onChange={(date) => {
                 
                    setFechaNacimiento(date);
                  }}
                />
              </div>
            ) : null}
            {/* <SelectInput
              value={crearAsistencia}
              setValue={setCrearAsistencia}
              label="Crear asistencia al crear contacto"
              options={crearAsistenciaOptions()}
            />
            {crearAsistencia === "SI" ? (
              <SelectInput
                value={poseeReserva}
                setValue={setPoseeReserva}
                label="Posee reserva"
                options={crearAsistenciaOptions()}
              />
            ) : null}
            {poseeReserva === "SI" ? (
              <SelectInput
                value={reserva}
                setValue={setReserva}
                label="SeleccionarReserva"
                options={reservaOptions}
              />
            ) : null} */}
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AddContacto;
